import React from "react";
import './App.css';
import Navigation from "./navigation";
import { store, persistor } from './redux/store'
import { Provider } from 'react-redux'
import { PersistGate } from "redux-persist/integration/react";

function App() {
        return (
                <>
                        <Provider store={store}>
                                <PersistGate loading={null} persistor={persistor}>
                                        <Navigation />
                                </PersistGate>
                        </Provider>
                </>
        )
}
export default App;
